'use strict';

var OperatorPing = require('actionGroups/operatorPing/OperatorPing');

module.exports = {
  Model: OperatorPing,
};
